import React, { Component } from "react";
import { Box } from "@mui/material";
import Nprogress from "nprogress";
import "nprogress/nprogress.css";

export default function AsyncComponent(importComponent) {
  class AsyncFunc extends Component {
    constructor(props) {
      super(props);
      this.state = {
        component: null,
      };
    }

    async componentDidMount() {
      this.mounted = true;
      Nprogress.start();
      try {
        const { default: Loaded } = await importComponent();
        if (this.mounted) {
          this.setState({ component: Loaded });
        }
      } finally {
        Nprogress.done();
      }
    }

    componentWillUnmount() {
      this.mounted = false;
    }

    render() {
      const Loaded = this.state.component;
      if (!Loaded) {
        return <Box sx={{ minHeight: "100vh", bgcolor: "background.default" }} />;
      }

      return <Loaded {...this.props} />;
    }
  }
  return AsyncFunc;
}
